import React from 'react'
import { IconReport } from '@tabler/icons-react'
import { ThemeConfig } from '../../utils/themeConfig'

interface HistoryOrdersButtonProps {
  onClick: () => void
  themeConfig: ThemeConfig
  className?: string
}

const HistoryOrdersButton: React.FC<HistoryOrdersButtonProps> = ({ onClick, themeConfig, className }) => {
  return (
    <div
      className={`flex flex-col items-center justify-center cursor-pointer p-3 transition-all duration-300 hover:scale-105 ${className || ''}`}
      onClick={onClick}
      style={{ backgroundColor: themeConfig.backgroundColor }}
    >
      <IconReport size={28} color={themeConfig.primaryColor} />
      <span className="text-gray-500 text-xs font-medium mt-1">历史报告</span>
    </div>
  )
}

export default HistoryOrdersButton
